import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { logEvent } from "lib/events";
import { theme } from "@ribondao/shared/styles";
import ArrowLeft from "assets/icons/arrow-left-green.svg";
import LeftImage from "assets/images/bottom-left-shape.svg";
import RightImage from "assets/images/top-right-sun-shape.svg";
import CardInfo from "components/moleculars/cards/CardInfo";
import useNavigation from "hooks/useNavigation";
import Button from "components/atomics/buttons/Button";
import Icon from "components/atomics/Icon";
import { useLocation } from "react-router-dom";
import RibonIcon from "./assets/ribon-icon.svg";
import * as S from "./styles";

export type LocationState = {
  hasButton?: boolean;
};

function ThirdPage(): JSX.Element {
  const {
    state: { hasButton = true },
  } = useLocation<LocationState>();
  const { t } = useTranslation("translation", {
    keyPrefix: "onboarding.thirdPage",
  });
  const { navigateBack, navigateTo } = useNavigation();

  const handleClick = () => {
    logEvent("p34_click");

    navigateTo("/auth/sign-in");
  };

  useEffect(() => {
    logEvent("P34_view", { from: "onboarding" });
  }, []);

  return (
    <S.Container>
      <S.LeftBackgroundImage src={LeftImage} />
      <S.RightBackgroundImage src={RightImage} />
      <S.ContentContainer>
        <S.BackArrowButton src={ArrowLeft} onClick={() => navigateBack()} />

        <S.Title>{t("title")}</S.Title>
        <CardInfo
          icon={
            <Icon
              name="confirmation_number"
              backgroundColor="transparent"
              withCircle
              color={theme.colors.brand.secondary[800]}
              size="20px"
            />
          }
          title={t("cardTitle1")}
          titleColor={theme.colors.neutral[800]}
          iconBackgroundColor={theme.colors.brand.secondary[100]}
          backgroundColor={theme.colors.brand.secondary[25]}
        >
          {t("cardDescription1")}
        </CardInfo>
        <CardInfo
          icon={
            <Icon
              name="volunteer_activism"
              backgroundColor="transparent"
              withCircle
              color={theme.colors.brand.secondary[800]}
              size="20px"
            />
          }
          title={t("cardTitle2")}
          titleColor={theme.colors.neutral[800]}
          iconBackgroundColor={theme.colors.brand.quaternary[100]}
          backgroundColor={theme.colors.brand.quaternary[25]}
        >
          {t("cardDescription2")}
        </CardInfo>
        <CardInfo
          icon={<S.Icon src={RibonIcon} />}
          title={t("cardTitle3")}
          titleColor={theme.colors.neutral[800]}
          iconBackgroundColor={theme.colors.brand.primary[100]}
          backgroundColor={theme.colors.brand.primary[50]}
        >
          {t("cardDescription3")}
        </CardInfo>
        {hasButton && (
          <S.ButtonContainer>
            <Button
              text={t("button")}
              backgroundColor={theme.colors.brand.primary[600]}
              borderColor={theme.colors.brand.primary[600]}
              borderRadius="4px"
              onClick={handleClick}
            />
          </S.ButtonContainer>
        )}
      </S.ContentContainer>
    </S.Container>
  );
}

export default ThirdPage;
